import React from 'react';
import { ReportCardComponent } from './components';
import { reportCards } from './reportsTypes';
import styles from './WarehouseReports.module.css';

const WarehouseReports: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {reportCards.map((report) => (
          <ReportCardComponent key={report.id} report={report} />
        ))}
      </div>
    </div>
  );
};

export const WarehouseReportsPage: React.FC = () => <WarehouseReports />;
export default WarehouseReports;
